import $ from 'jquery';

const SLIDE_TIME =  "fast";

// for Alerting & GMS
const SELECTOR = {
    CLASS_MENU_LEFT_TOGGLE: ".js-menu-left_toggle",
    CLASS_BTN_ACTIVE: ".is-open",
    CLASS_PARENT_ACTIVE: ".parent-active",
    CLASS_FIRST_LI: ".js-secondlvl-link",
    CLASS_NAV_LEFT: ".js-container-sublevel",
    CLASS_CONTAINER_MAIN: ".rsp_main"
};

const CLASS = {
    PARENT_ACTIVE: "parent-active",
    FIRST_LI: "js-secondlvl-link"
};

export function initToggles() {
    processHeightMain();
    $(document).on('click',SELECTOR.CLASS_MENU_LEFT_TOGGLE,function(event){
        event.stopPropagation();
        toggleBtn(this);

        return false;
    });
}

function toggleBtn(button) {
    var $btn = $(button);

    closeOthers($btn);
    processBtn($btn);
}

function closeOthers($btn) {
    var $parent = $btn.parents(SELECTOR.CLASS_FIRST_LI);
    var needToKeepParent = true;
    var $btnActive = $(SELECTOR.CLASS_BTN_ACTIVE);

    if (!$parent.hasClass(CLASS.PARENT_ACTIVE)) {
        needToKeepParent = false;
        $(SELECTOR.CLASS_FIRST_LI).removeClass(CLASS.PARENT_ACTIVE);
        $parent.addClass(CLASS.PARENT_ACTIVE);
    }

    $btnActive.each(function() {
        var $btnCurrent = $(this);

        // escape to close parent if lvl 3
        if ((needToKeepParent) && ($btnCurrent.parent().hasClass(CLASS.FIRST_LI))) {
            return;
        }

        if ($btnCurrent.is($btn)) {
            return;
        }

        closeAccordian($btnCurrent);
    });
}

function closeAccordian($btnCurrent) {
    $btnCurrent.removeClass("is-open");
    $btnCurrent.next().stop(true).slideUp(SLIDE_TIME);
    $btnCurrent.children("svg").toggleClass("is-up");
}

function processBtn($btn) {
    $btn.next().stop(true).slideToggle(SLIDE_TIME, processHeightMain());
    $btn.children("svg").toggleClass("is-up");
    $btn.toggleClass("is-open");
}

function processHeightMain() {
    setTimeout(processAfterTime, 250);

    function processAfterTime() {
        var heightNav = $(SELECTOR.CLASS_NAV_LEFT).outerHeight();
        var containerMain = document.querySelector(SELECTOR.CLASS_CONTAINER_MAIN);
        if (typeof(containerMain) != 'undefined' && containerMain != null) {
            containerMain.style.minHeight = heightNav + "px";
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/menu-toggle/menuToggle.js